import { render, staticRenderFns } from "./searchInfo.vue?vue&type=template&id=2a1c7f01&scoped=true"
import script from "./searchInfo.vue?vue&type=script&lang=js"
export * from "./searchInfo.vue?vue&type=script&lang=js"
import style0 from "./searchInfo.vue?vue&type=style&index=0&id=2a1c7f01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c7f01",
  null
  
)

export default component.exports